import { useTheme } from "styled-components";
import { Color } from "@/utils/theme";

const useDropGraph = (
  labels: number[],
  data: number[],
  filteredRetentions: number[],
  filteredRetentionIndexes: number[]
) => {
  const theme = useTheme();

  const color: Color = "purpleLighter";

  const graphOptions = {
    responsive: true,

    layout: {
      padding: {
        top: 4,
        bottom: 1,
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
          callback: function (index: string | number) {
            return filteredRetentionIndexes?.find(
              (retentionIndex: number) => retentionIndex === index
            )
              ? ""
              : null;
          },
        },
        grid: {
          borderWidth: 0,
          color: "rgba(246, 70, 41, 0.3)",
          tickLength: 0,
          lineWidth: 2,
        },
      },
      y: {
        display: false,
      },
    },
  };

  const graphData = {
    labels,
    datasets: [
      {
        data,
        borderColor: theme.colors[color],
        borderWidth: 2,
        backgroundColor: "rgba(93, 84, 214, 0.1)",
        pointRadius: customRadius,
        pointHoverBorderWidth: 2,
        pointBorderColor: theme.colors[color],
        fill: "origin",
        pointBackgroundColor: theme.colors.white,
      },
    ],
  };
  // TODO: remove any type
  function customRadius(context: any) {
    let index = context.dataIndex;
    let value = context.dataset.data[index];
    return filteredRetentions?.find((retention: number) => retention === value)
      ? 3
      : 0;
  }

  return { color, graphData, graphOptions };
};

export default useDropGraph;
